import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemDescription from "components/ListEntitiesItem/Description";
import ListEntitiesItemTitle from "components/ListEntitiesItem/Title";
import Box from "ds/components/Box";
import { useDrawerVisibilityForId } from "ds/components/DrawerNew/useDrawerVisibilityForId";
import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

import {
  BUILT_IN_GITHUB_INTEGRATION_DESCRIPTION,
  BUILT_IN_GITHUB_INTEGRATION_NAME,
  COLUMN_GAP,
  COLUMN_ORDER,
  GITHUB_INTEGRATION_DETAILS_DRAWER_ID,
} from "../../shared/VcsList/constants";
import VCSProviderIcon from "../../shared/VcsShared/components/ProviderIcon";
import VCSIntegrationsBuiltInGitHubListItemDropdownActions from "./BuiltInGitHubDropdownActions";

type VCSIntegrationsBuiltInGitHubListItemProps = {
  onEdit: () => void;
  onShowDetails: () => void;
};

const VCSIntegrationsBuiltInGitHubListItem = ({
  onEdit,
  onShowDetails,
}: VCSIntegrationsBuiltInGitHubListItemProps) => {
  const isDetailsDrawerVisible = useDrawerVisibilityForId(GITHUB_INTEGRATION_DETAILS_DRAWER_ID);
  const { viewer } = useTypedContext(AccountContext);

  return (
    <ListEntitiesItem
      direction="row"
      align="center"
      justify="between"
      grid
      gridTemplate={COLUMN_ORDER}
      gap={`0 ${COLUMN_GAP}`}
      isActive={isDetailsDrawerVisible}
    >
      <Box gap="large">
        <VCSProviderIcon provider={VcsProvider.Github} tile />

        <Box grow="1">
          <Box direction="column" fullWidth>
            <ListEntitiesItemTitle
              title={BUILT_IN_GITHUB_INTEGRATION_NAME}
              titleVariant="p-body2"
            />

            <Box direction="row" align="start" fullWidth>
              <ListEntitiesItemDescription
                noPadding
                description={BUILT_IN_GITHUB_INTEGRATION_DESCRIPTION}
                tooltipMode
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <VCSIntegrationsBuiltInGitHubListItemDropdownActions
        onShowDetails={onShowDetails}
        onEdit={onEdit}
        canManageVCSIntegrations={viewer.admin}
      />
    </ListEntitiesItem>
  );
};

export default VCSIntegrationsBuiltInGitHubListItem;
